import { Box } from "@mui/material";
import Fab from "@mui/material/Fab";
import { useCallback, useEffect, useState } from "react";
import { MdKeyboardArrowUp } from "react-icons/md";

export const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  const scrollToTop = useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 100) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    <Box
      onClick={scrollToTop}
      sx={{
        position: "fixed",
        bottom: 32,
        right: 32,
        zIndex: 40,
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateY(0)" : "translateY(100px)",
        transition: "all 0.3s ease",
      }}
    >
      <Fab
        size="small"
        sx={{
          backgroundColor: "#1FADB2",
          color: "white",
          "&:hover": {
            backgroundColor: "#147275",
          },
        }}
      >
        <MdKeyboardArrowUp />
      </Fab>
    </Box>
  );
};
